import { useReveal } from "../../lib/reveal";

const quotes = [
  {
    body:
      "Recebemos relatos de alunos chorando ao abrir o kit. Virou parte da jornada — não um brinde, uma experiência.",
    name: "Marina Andrade",
    role: "Fundadora · Imersão Líder Premium",
  },
  {
    body:
      "Profissionalismo do briefing à logística. A MetierCom nos posicionou em outro patamar perante nossos alunos.",
    name: "Rafael Tomé",
    role: "Head de Educação · Programa Anual",
  },
  {
    body:
      "Toda vez que rodamos uma nova turma, a MetierCom entrega antes do prazo e o NPS do kit é altíssimo.",
    name: "Camila Borges",
    role: "Mentora · Performance & Vendas",
  },
];

export default function Depoimentos() {
  const { ref, visible } = useReveal();
  return (
    <section
      id="depoimentos"
      ref={ref}
      data-testid="depoimentos-section"
      className="py-24 md:py-32"
      style={{ backgroundColor: "#DFDBD1" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`max-w-3xl mb-14 md:mb-20 reveal ${visible ? "in" : ""}`}>
          <p className="overline">Quem confia na Remind</p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1C1C1C] mt-6 leading-[1.05]">
            Produtores que <em className="italic text-[#556052]">elevaram</em> seu posicionamento.
          </h2>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 reveal ${visible ? "in" : ""}`}>
          {quotes.map((q, i) => (
            <blockquote
              key={i}
              data-testid={`depoimento-${i}`}
              className="bg-[#FAFAFA] p-8 md:p-10 border border-[rgba(28,28,28,0.06)] transition-all duration-500 hover:-translate-y-1"
            >
              <span className="font-serif text-6xl text-[#C5A059] leading-none block -mb-4">“</span>
              <p className="font-serif text-xl md:text-2xl text-[#1C1C1C] leading-snug font-light">
                {q.body}
              </p>
              <footer className="mt-8 pt-6 border-t border-[rgba(28,28,28,0.08)]">
                <p className="text-sm font-medium text-[#1C1C1C]">{q.name}</p>
                <p className="overline mt-1 text-[#556052]">{q.role}</p>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
